import React, { useEffect, useState } from "react";
import HeaderInfos from "./components/HeaderInfos";
import Table from "./components/Table";
import GlobalChart from "./components/GlobalChart";
import CoinModal from "./components/CoinModal";
import axios from "axios";
import { data as fallbackData } from "./db";

const App = () => {
  const [coinsData, setCoinsData] = useState(fallbackData || []);
  const [searchTerm, setSearchTerm] = useState("");
  const [viewMode, setViewMode] = useState("table");
  const [selectedCoin, setSelectedCoin] = useState(null);

  useEffect(() => {
    axios
      .get(
        `https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&order=market_cap_desc&per_page=250&page=1&sparkline=true&price_change_percentage=1h%2C24h%2C7d%2C14d%2C30d%2C200d%2C1y`
      )
      .then((res) => {
        if (res.data && res.data.length > 0) {
          setCoinsData(res.data);
        }
      })
      .catch((err) => {
        console.warn("CoinGecko API request rate limited or failed, using local offline dataset fallback:", err);
      });
  }, []);

  return (
    <div className="app-container">
      <header>
        <HeaderInfos
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          viewMode={viewMode}
          setViewMode={setViewMode}
        />
        <GlobalChart coinsData={coinsData} onOpenModal={(coin) => setSelectedCoin(coin)} />
      </header>

      <main>
        <Table
          coinsData={coinsData}
          searchTerm={searchTerm}
          viewMode={viewMode}
          onOpenModal={(coin) => setSelectedCoin(coin)}
        />
      </main>

      {selectedCoin && (
        <CoinModal
          coin={selectedCoin}
          onClose={() => setSelectedCoin(null)}
        />
      )}
    </div>
  );
};

export default App;
